import { injectable } from 'tsyringe';
import { InternalService } from '../../core/services';
import { IEnvironmentVariablesService } from './IEnvironmentVariablesService';
import {
  EnvironmentVariableContextNotFoundError,
  type EnvironmentVariablesInputType
} from './types';
import { SerializableObject } from '@clientos/types';

@injectable()
export default class EnvironmentVariablesService
  extends InternalService
  implements IEnvironmentVariablesService
{
  private _environmentVariables: Record<string, SerializableObject>;

  constructor(environmentVariablesConfig: EnvironmentVariablesInputType) {
    super();
    this._environmentVariables = environmentVariablesConfig || {};
  }

  public async init(): Promise<void> {
    this._markAsInitializing();
    this._markAsReady();
  }

  public async get(context: string): Promise<SerializableObject> {
    const contextData = this._environmentVariables[context];

    if (!contextData) {
      throw new EnvironmentVariableContextNotFoundError(context);
    }

    return { ...contextData };
  }

  public async listContexts(): Promise<string[]> {
    return Object.keys(this._environmentVariables);
  }
}
